import { useState } from "react";
import { useProductForm } from "../../contexts/ProductFormContext";
import { ImBin } from "react-icons/im";
import { toast } from "react-toastify";

export const SpecTab = () => {
  const { product, setProduct } = useProductForm();
  const [formSpecs, setFormSpecs] = useState<{ key: string; value: string }>({
    key: "",
    value: "",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormSpecs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div className="p-5 rounded-xl border border-gray-100 bg-white space-y-2">
      <h2 className="text-lg text-black font-semibold">Đặc tinh sản phẩm</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <div className="space-y-2">
          <label className="block text-sm text-gray-700 font-semibold">
            Tên đặc tính
          </label>
          <input
            type="text"
            name="key"
            value={formSpecs.key}
            onChange={handleChange}
            className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
            placeholder="Nguồn điện"
          />
        </div>
        <div className="space-y-2">
          <label className="block text-sm text-gray-700 font-semibold">
            Giá trị đặc tính
          </label>
          <input
            type="text"
            name="value"
            value={formSpecs.value}
            onChange={handleChange}
            className="w-full p-2 focus:outline-none focus:border-blue-500 rounded-lg border border-gray-200 placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
            placeholder="220V"
          />
        </div>
        <button
          type="button"
          onClick={() => {
            if (formSpecs.key === "" || formSpecs.value === "") {
              toast.error("Vui lòng nhập đủ thông tin đặc tính");
              return;
            }
            setProduct((prev) => ({
              ...prev,
              product: {
                ...prev.product,
                specs: [...prev.product.specs, formSpecs],
              },
            }));
            setFormSpecs({
              key: "",
              value: "",
            });
          }}
          className="p-2 bg-blue-500 hover:bg-blue-600 transition-colors duration-300 text-white rounded-lg text-sm cursor-pointer"
        >
          Thêm đặc tính
        </button>
      </div>
      <div className="overflow-x-auto scrollbar-custom">
        <table className="w-full">
          <thead className="border border-gray-200">
            <tr className="bg-blue-50 divide-x divide-gray-200">
              <th>
                <p className="p-2 text-[11px] uppercase tracking-wider text-gray-400 font-semibold text-center">
                  Tên đặc tính
                </p>
              </th>
              <th>
                <p className="p-2 text-[11px] uppercase tracking-wider text-gray-400 font-semibold text-center">
                  Giá trị đặc tính
                </p>
              </th>
              <th>
                <p className="p-2 text-[11px] uppercase tracking-wider text-gray-400 font-semibold text-center">
                  Thao tác
                </p>
              </th>
            </tr>
          </thead>
          <tbody className="border border-gray-200">
            {product.product.specs.length > 0 ? (
              product.product.specs.map((spec, index) => (
                <tr
                  key={index}
                  className="border-t border-gray-100 hover:bg-gray-50/50 transition-colors"
                >
                  <td>
                    <p className="p-2 text-sm text-gray-700 text-center">
                      {spec.key}
                    </p>
                  </td>
                  <td>
                    <p className="p-2 text-sm text-gray-700 text-center">
                      {spec.value}
                    </p>
                  </td>
                  <td>
                    <div className="flex items-center justify-center gap-2">
                      <button
                        type="button"
                        onClick={() => {
                          setProduct((prev) => ({
                            ...prev,
                            product: {
                              ...prev.product,
                              specs: prev.product.specs.filter(
                                (_, i) => i !== index,
                              ),
                            },
                          }));
                        }}
                        className="text-xl text-gray-700 hover:text-red-500 transition-colors duration-300 cursor-pointer"
                      >
                        <ImBin />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3}>
                  <p className="p-2 text-sm text-gray-700 text-center">
                    Không có đặc tính nào
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
